import React from 'react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  return <section className="py-8 px-4 bg-amber-50/60" data-id="element-225">
      <div className="max-w-2xl mx-auto text-left md:text-center space-y-3" data-id="element-226">
        <p className="text-xl font-bold text-gray-800" data-id="element-227">
          Si sos mamá o papá, dejame hacerte una pregunta honesta
        </p>

        <h2 className="text-3xl md:text-4xl font-extrabold text-red-600 leading-tight" data-id="element-228">
          ¿Sentís que los días pasan rápido… pero los momentos importantes se te
          escapan?
        </h2>

        <div className="space-y-2 text-lg text-gray-700" data-id="element-229">
          <p data-id="element-230">No porque no ames a tus hijos. No porque no quieras estar.</p>
          <p data-id="element-231">
            Sino porque la rutina, el cansancio y las pantallas lo ocupan todo.
          </p>
          <p className="font-bold" data-id="element-232">Y cuando te das cuenta… el día terminó.</p>
          <p className="italic bg-yellow-50 p-3 border-l-4 border-yellow-400 rounded-r" data-id="element-233">
            Y queda ese pensamiento silencioso:
            <br data-id="element-234" />
            <span className="font-bold" data-id="element-235">
              "Podría estar haciendo más… si supiera cómo."
            </span>
          </p>
        </div>

        <div className="mt-6 p-4 bg-white/70 rounded-xl border border-amber-100" data-id="element-236">
          <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-237">
            El problema del que casi nadie habla
          </h3>
          <p className="text-lg mb-3" data-id="element-238">
            Pasamos tiempo juntos, sí. Pero muchas veces no hay conexión real.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-left font-medium text-gray-800" data-id="element-239">
            <div className="flex items-center gap-2" data-id="element-240">
              📱 Cada uno con su celular
            </div>
            <div className="flex items-center gap-2" data-id="element-241">😶 Poco diálogo</div>
            <div className="flex items-center gap-2" data-id="element-242">🎮 Poco juego</div>
            <div className="flex items-center gap-2" data-id="element-243">💭 Poca presencia</div>
          </div>
          <p className="mt-3 text-lg" data-id="element-244">
            Y aparece la culpa. No porque no estés… sino porque sentís que no
            alcanza.
          </p>
        </div>

        <div className="pt-4" data-id="element-245">
          <CTAButton text="🔥 QUIERO DEJAR DE SENTIR CULPA" subtext="Empezar ahora mismo" data-id="element-246" />
        </div>
      </div>
    </section>;
}